import axios from "axios";
import { json } from "react-router-dom";

import { signatureBatchLink } from "../../api/signer";

export async function loader({ params }): Promise<Response> {
  try {
    const { hash } = params as { hash: string };

    const { data: documentSignatures } = await signatureBatchLink(hash);
    return json({ ...documentSignatures, hasExpired: false }, { status: 200 });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 400) {
        const { objects } = e.response.data as {
          objects?: ResponseObjectsError[];
        };
        if (objects) {
          return json({ hasExpired: true, objects }, { status: 400 });
        }
        return json({ hasExpired: true }, { status: 400 });
      }
      // eslint-disable-next-line @typescript-eslint/no-throw-literal -- expected
      throw json(e.response, { status: e.response?.status || 500 });
    }
    // eslint-disable-next-line @typescript-eslint/no-throw-literal -- expected
    throw json(e, { status: 500 });
  }
}
